import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { Button, Modal } from '../../../../../common/_custom';
import { setDeleteUserModal } from '../../../../../store/investor/action';
import { editUserDetailsV2 } from '../../../../../store/investor/apiHelpers';
import { toast } from 'react-toastify';
import { Mixpanel } from '../../../../../utils/mixpanel';
import { AICA_USER_DELETED } from '../../../../../utils/constants/mixpanelEvents/investorEvents';
import styles from './DeleteUserModal.module.scss';

interface DeleteUserModalProps {
    isOpen: boolean;
    userData: any;
    onClose: () => void;
    onUsersUpdate?: (updatedUsers: any[]) => void;
    allRowsData?: any[];
}

const DeleteUserModal = ({ isOpen, userData, onClose, onUsersUpdate, allRowsData }: DeleteUserModalProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const currentUser = useAppSelector((state) => state.user.userData);
    const platformData = useAppSelector((state) => state.user.domainMetadata);

    const handleDelete = async () => {
        if (!userData?.userId) return;

        setLoading(true);
        try {
            const response = await editUserDetailsV2({ userDetails: { userId: userData.userId, isDeleted: true } });
            if (response?.responseData) {
                toast.success('User deleted successfully');
                Mixpanel.track(AICA_USER_DELETED, {
                    deleted_user_type: userData.userType,
                    user_email: userData.emailId,
                    currentUrl: window.location.href,
                    org_type: currentUser?.accountType,
                    orgId: userData.organizationId,
                    pnoId: platformData?.investorOrgId,
                });
                if (allRowsData && onUsersUpdate) {
                    onUsersUpdate(allRowsData.filter((row) => row.userId !== userData.userId));
                }
            }
        } catch (error) {
            console.error('Failed to delete user:', error);
        } finally {
            setLoading(false);
            dispatch(setDeleteUserModal(false));
        }
    };

    return (
        <Modal open={isOpen} onClose={onClose} size="flexible" persistent style={{ padding: 0 }}>
            <div className={styles.ModalContainer}>
                <div className={styles.ModalHeader}>
                    <div className={styles.Title}>Delete User</div>
                    <div className={styles.Subtitle}>Are you sure you want to delete this user?</div>
                </div>
                <div className={styles.ModalFooter}>
                    <Button text="Cancel" variant="purpleinverted" onClick={onClose} disabled={loading} style={{ flex: 1, margin: 0 }} />
                    <Button
                        text="Delete"
                        variant="orange"
                        onClick={handleDelete}
                        loading={loading}
                        disabled={loading}
                        style={{ flex: 1, margin: 0 }}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default DeleteUserModal;
